import { useState, useEffect } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import Swal from "sweetalert2";
import axios from "axios";

export default function Add_data_modal({
  select_data,
  open_update_data_modal,
  onUpdateScrap,
}) {
  const [ren, setRen] = useState(false);
  const [update_modal_data, setUpdate_modal_data] = useState(select_data);
  const [add_data_modal_Show, set_update_data_modal_Show] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [errors, setErrors] = useState({});
  const [vehicles, setVehicles] = useState([]);
  const [users, setUsers] = useState([]);

  const [clients, setClients] = useState([]);

  useEffect(() => {
    if (select_data) {
      setUpdate_modal_data({
        ...select_data,
        id_vehicle: select_data.id_vehicle ? select_data.id_vehicle._id : "",
        actual_vehicle: select_data.actual_vehicle
          ? select_data.actual_vehicle._id
          : "",

        id_client: select_data.id_client ? select_data.id_client._id : "",
        id_user: select_data.id_user ? select_data.id_user._id : "",
      });
    }
  }, [select_data]);

  useEffect(() => {
    set_update_data_modal_Show(open_update_data_modal.modal_open);
  }, [open_update_data_modal]);

  const handleClose = () => {
    set_update_data_modal_Show(false);
  };
  useEffect(() => {
    const fetchUsers = async () => {
      try {
        const token = localStorage.getItem("token");
        if (!token) {
          console.error("No token found");
          return;
        }
        const response = await axios.get(
          `${process.env.REACT_APP_BASE_URL}/api/v1/admin/users`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          },
        );
        setUsers(response.data.users || []);
      } catch (error) {
        console.error("Error fetching users:", error);
        setUsers([]);
      }
    };

    const fetchVehicles = async () => {
      try {
        const token = localStorage.getItem("token");
        if (!token) {
          console.error("No token found");
          return;
        }
        const response = await axios.get(
          `${process.env.REACT_APP_BASE_URL}/api/v1/vehicles`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          },
        );
        setVehicles(response.data.vehicles);
      } catch (error) {
        console.error("Error fetching vehicles:", error);
        setVehicles([]);
      }
    };

    const fetchClients = async () => {
      try {
        const token = localStorage.getItem("token");
        if (!token) {
          console.error("No token found");
          return;
        }
        const response = await axios.get(
          `${process.env.REACT_APP_BASE_URL}/api/v1/clients`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          },
        );
        setClients(response.data.clients);
      } catch (error) {
        console.error("Error fetching client:", error);
        setClients([]);
      }
    };
    fetchUsers();
    fetchVehicles();
    fetchClients();
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === "id_vehicle") {
      setUpdate_modal_data((prevData) => ({
        ...prevData,
        id_vehicle: { ...prevData.id_vehicle, [name]: value },
      }));
    } else if (name === "actual_vehicle") {
      setUpdate_modal_data((prevData) => ({
        ...prevData,
        actual_vehicle: { ...prevData.actual_vehicle, [name]: value },
      }));
    } else if (name === "id_user") {
      setUpdate_modal_data((prevData) => ({
        ...prevData,
        id_user: { ...prevData.id_user, [name]: value },
      }));
    } else if (name === "id_client") {
      setUpdate_modal_data((prevData) => ({
        ...prevData,
        id_client: { ...prevData.id_client, [name]: value },
      }));
    } else {
      setUpdate_modal_data({ ...update_modal_data, [name]: value });
    }
  };

  const handleUserChange = (e) => {
    const { value } = e.target;
    // Set the id_user to either the selected value or an empty string (null)
    setUpdate_modal_data((prevData) => ({
      ...prevData,
      id_user: value || null,
    }));
  };

  const handleVehicleChange = (e) => {
    const { value } = e.target;
    setUpdate_modal_data((prevData) => ({
      ...prevData,
      id_vehicle: value,
    }));
  };

  const handleActualVehicleChange = (e) => {
    const { value } = e.target;
    setUpdate_modal_data((prevData) => ({
      ...prevData,
      actual_vehicle: value,
    }));
  };

  const handleClientChange = (e) => {
    const { value } = e.target;

    setUpdate_modal_data((prevData) => ({
      ...prevData,
      id_client: value, // always store only the ID
    }));
  };

  const validateFields = () => {
    const newErrors = {};
    if (!update_modal_data.id_vehicle)
      newErrors.id_vehicle = "Vehicle is required";
    if (!update_modal_data.actual_vehicle)
      newErrors.actual_vehicle = "Actual Vehicle is required";
    if (!update_modal_data.id_client)
      newErrors.id_client = "Client is required";

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleUpdate = async () => {
    const token = localStorage.getItem("token");

    if (!validateFields()) {
      Swal.fire("Please fill in all required fields", "", "error");
      return;
    }

    Swal.fire({
      icon: "warning",
      title: "Are you sure you want to take this action?",
      showCancelButton: true,
      confirmButtonText: "Yes",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          const { _id } = update_modal_data;
          if (!_id) {
            throw new Error("ID is not defined");
          }

          // Create a new FormData object
          const formData = new FormData();
          if (update_modal_data.id_user) {
            formData.append("id_user", update_modal_data.id_user);
          }
          formData.append("id_vehicle", update_modal_data.id_vehicle);
          formData.append("actual_vehicle", update_modal_data.actual_vehicle);

          formData.append("id_client", update_modal_data.id_client);
          formData.append("comments", update_modal_data.comments);

          const res = await axios.put(
            `${process.env.REACT_APP_BASE_URL}/api/v1/scrap/${_id}`,
            formData,
            {
              headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type": "application/json",
              },
            },
          );

          if (res.data.success) {
            Swal.fire("Update success", "", "success");
            onUpdateScrap(update_modal_data);
            setRen(!ren);
          }
        } catch (error) {
          Swal.fire("Update failed", "", "error");
        }
        set_update_data_modal_Show(false);
      } else if (result.isDenied) {
        Swal.fire("Changes are not saved", "", "info");
      }
    });
  };

  return (
    <>
      <Modal show={add_data_modal_Show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Update Data</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group className="mb-3" controlId="id_user">
              <Form.Label>Client Name *</Form.Label>
              <Form.Control
                as="select"
                name="id_client"
                // 👉 Handle both: populated object OR plain id
                value={
                  typeof update_modal_data.id_client === "object"
                    ? update_modal_data.id_client?._id || ""
                    : update_modal_data.id_client || ""
                }
                onChange={handleClientChange}
                isInvalid={!!errors.id_client}
              >
                <option value="">Select Client</option>

                {clients
                  .filter((client) => client.status?.toLowerCase() === "active")

                  .map((client) => (
                    <option key={client._id} value={client._id}>
                      {client.name}
                    </option>
                  ))}
              </Form.Control>

              <Form.Control.Feedback type="invalid">
                {errors.id_client}
              </Form.Control.Feedback>
            </Form.Group>
            <Form.Group className="mb-3" controlId="id_user">
              <Form.Label>Actual User </Form.Label>
              <Form.Control
                as="select"
                name="id_user"
                value={update_modal_data.id_user || ""}
                onChange={handleUserChange}
                isInvalid={!!errors.id_user}
              >
                <option value="">Select User</option>
                {users
                  .filter((user) => user.status?.toLowerCase() === "active")
                  .map((user) => (
                    <option key={user._id} value={user._id}>
                      {/* {user.name} */}
                      {user.name || "Unknown Name"} (
                      {user.phonenumber || "Unknown Phone"} )
                    </option>
                  ))}
              </Form.Control>
            </Form.Group>

            <Form.Group className="mb-3" controlId="id_user">
              <Form.Label>Vehicle *</Form.Label>
              <Form.Control
                as="select"
                name="id_vehicle"
                value={update_modal_data.id_vehicle || ""}
                onChange={handleVehicleChange}
                isInvalid={!!errors.id_vehicle}
              >
                <option value="">Select Vehicle</option>
                {vehicles
                  .filter(
                    (vehicle) => vehicle.status?.toLowerCase() === "active",
                  )
                  .map((vehicle) => (
                    <option key={vehicle._id} value={vehicle._id}>
                      {vehicle.numberplate}
                    </option>
                  ))}
              </Form.Control>
              <Form.Control.Feedback type="invalid">
                {errors.id_vehicle}
              </Form.Control.Feedback>
            </Form.Group>

            <Form.Group className="mb-3" controlId="id_user">
              <Form.Label>Actual Vehicle *</Form.Label>
              <Form.Control
                as="select"
                name="actual_vehicle"
                value={update_modal_data.actual_vehicle || ""}
                onChange={handleActualVehicleChange}
                isInvalid={!!errors.actual_vehicle}
              >
                <option value="">Select Actual Vehicle</option>
                {vehicles
                  .filter(
                    (vehicle) => vehicle.status?.toLowerCase() === "active",
                  )
                  .map((vehicle) => (
                    <option key={vehicle._id} value={vehicle._id}>
                      {vehicle.numberplate}
                    </option>
                  ))}
              </Form.Control>
              <Form.Control.Feedback type="invalid">
                {errors.actual_vehicle}
              </Form.Control.Feedback>
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Comments *</Form.Label>
              <Form.Control
                type="text"
                name="comments"
                value={update_modal_data.comments || ""}
                onChange={handleChange}
                isInvalid={!!errors.comments}
              />
              <Form.Control.Feedback type="invalid">
                {errors.comments}
              </Form.Control.Feedback>
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
          <Button
            variant="primary"
            className="btn btn-sm"
            onClick={handleUpdate}
          >
            Update Data
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}
